(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regional-bis-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    class RegionalBisModal extends ModalDialog {
      constructor() {
        super();
        this.form = this.querySelector('[data-rb-form]');
        this.titleEl = this.querySelector('[data-rb-title]');
        this.variantWrapper = this.querySelector('[data-rb-variant-wrapper]');
        this.variantSelect = this.querySelector('[data-rb-variant-select]');
        this.emailInput = this.querySelector('input[name="email"]');
        this.submitBtn = this.querySelector('[data-rb-submit]');
        this.submitCopy = this.querySelector('[data-rb-submit-copy]');
        this.successEl = this.querySelector('[data-rb-success]');
        this.successCopy = this.querySelector('[data-rb-success-copy]');
        this.errorEl = this.querySelector('[data-rb-error]');
        this.errorCopy = this.querySelector('[data-rb-error-copy]');
        this.data = JSON.parse(this.querySelector('[data-rb-json]').textContent);
        this.defaultSubmitCopy = this.submitCopy.textContent;
        this.defaultErrorCopy = this.errorCopy.textContent;

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        // ModalDialog's own backdrop-click handler only matches its literal
        // <modal-dialog> tag name, so it never fires for this custom tag.
        this.addEventListener('click', (e) => {
          if (e.target === this) this.hide();
        });
      }

      show(opener) {
        super.show(opener);
        this.resetMessages();
        this.populate();
        if (this.data.variants.length === 0) {
          // Every variant is back in stock (a stale trigger fired after a
          // restock, before the page re-checked availability) — there's
          // nothing left to notify on.
          this.form.hidden = true;
          this.errorCopy.textContent = 'This item is back in stock.';
          this.errorEl.hidden = false;
        } else {
          this.emailInput.focus();
        }
      }

      populate() {
        const { product, variants, selectedVariantId } = this.data;
        this.titleEl.textContent = product.title;

        const mainOptionSelect = document.querySelector('[data-option-main]');
        const requestedVariantId = mainOptionSelect && mainOptionSelect.value
          ? Number(mainOptionSelect.value)
          : selectedVariantId;

        // this.data.variants is already filtered server-side to out-of-stock
        // options only. If the page's active variant isn't one of them, fall
        // back to the first out-of-stock option instead of pointing the
        // alert at a variant that's actually available.
        const activeVariantId = variants.some((v) => v.id === requestedVariantId)
          ? requestedVariantId
          : (variants[0] && variants[0].id);

        this.activeVariantId = activeVariantId;

        if (this.data.hasOnlyDefaultVariant) {
          this.variantWrapper.classList.add('is-hidden');
        } else {
          this.variantSelect.innerHTML = variants
            .map((variant) => `<option value="${variant.id}">${variant.title}</option>`)
            .join('');
          this.variantSelect.value = activeVariantId;
          this.variantWrapper.classList.remove('is-hidden');
        }
      }

      resetMessages() {
        this.successEl.hidden = true;
        this.errorEl.hidden = true;
        this.form.hidden = false;
      }

      handleSubmit(event) {
        event.preventDefault();

        const variantId = this.data.hasOnlyDefaultVariant
          ? this.activeVariantId
          : Number(this.variantSelect.value);
        const variant = this.data.variants.find((v) => v.id === variantId) || {};

        const payload = {
          email: this.emailInput.value.trim(),
          variant_id: variantId,
          variant_title: variant.title || '',
          variant_image: variant.image || '',
          variant_url: variant.url || this.data.product.url,
          product_id: this.data.product.id,
          product_title: this.data.product.title,
          product_handle: this.data.product.handle,
          product_url: this.data.product.url,
          warehouse: this.data.warehouse,
          market: this.data.market,
          shop: this.data.shop,
          timestamp: new Date().toISOString(),
        };

        this.submitBtn.disabled = true;
        this.submitCopy.textContent = '…';
        this.errorEl.hidden = true;

        // A plain POST with a text/plain body avoids a CORS preflight (Apps
        // Script has no doOptions to answer one), and script.google.com adds
        // Access-Control-Allow-Origin itself, so the JSON response is
        // readable without mode: 'no-cors'.
        fetch(this.data.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
        })
          .then((res) => res.json().catch(() => ({ status: res.status })))
          .then((data) => {
            const succeeded = data && data.status >= 200 && data.status < 300;
            if (succeeded) {
              this.successCopy.textContent = `We'll be in touch as soon as ${this.data.product.title} becomes available.`;
              this.successEl.hidden = false;
              this.form.hidden = true;
            } else {
              this.errorCopy.textContent = (data && data.message) || this.defaultErrorCopy;
              this.errorEl.hidden = false;
            }
          })
          .catch(() => {
            this.errorCopy.textContent = this.defaultErrorCopy;
            this.errorEl.hidden = false;
          })
          .finally(() => {
            this.submitBtn.disabled = false;
            this.submitCopy.textContent = this.defaultSubmitCopy;
          });
      }
    }

    if (!customElements.get('regional-bis-modal')) {
      customElements.define('regional-bis-modal', RegionalBisModal);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["teaser-popup"] && !Shopify.designMode) return;
  try {
    (function () {
        // Verify this revision against developers.klaviyo.com before changing.
        var KLAVIYO_API_REVISION = '2024-10-15';

        function safeGet(key) {
          try {
            return window.localStorage.getItem(key);
          } catch (e) {
            return null;
          }
        }

        function safeSet(key, value) {
          try {
            window.localStorage.setItem(key, value);
          } catch (e) {
            /* no-op: storage unavailable (private mode, quota, etc.) */
          }
        }

        function pushDataLayer(payload) {
          if (window.dataLayer) window.dataLayer.push(payload);
        }

        class WwTeaserPopup extends ModalDialog {
          constructor() {
            super();
            this.config = JSON.parse(this.querySelector('[data-ww-teaser-json]').textContent);
            this.dialogEl = this.querySelector('[role="dialog"]');
            this.form = this.querySelector('[data-ww-teaser-form]');
            this.emailInput = this.querySelector('[data-ww-teaser-email]');
            this.honeypotInput = this.querySelector('[data-ww-teaser-honeypot]');
            this.submitBtn = this.querySelector('[data-ww-teaser-submit]');
            this.submitCopy = this.querySelector('[data-ww-teaser-submit-copy]');
            this.statusEl = this.querySelector('[data-ww-teaser-status]');
            this.videoEl = this.querySelector('[data-ww-teaser-video]');
            this.audioToggle = this.querySelector('[data-ww-teaser-audio-toggle]');
            this.closeBtn = this.querySelector('[id^="ModalClose-"]');
            this.defaultSubmitCopy = this.submitCopy ? this.submitCopy.textContent : '';
            this.hasUnmuted = false;
            this.submittedKey = 'wwTeaser:' + this.config.handle + ':submitted';
            this.dismissedKey = 'wwTeaser:' + this.config.handle + ':dismissed';

            // Deliberately no backdrop-click-to-close: an accidental tap near
            // the edge (easy to do on mobile) would cost a real prospective
            // signup a full 24h dismissed-suppression window. Esc and the
            // close button remain as the two intentional ways to dismiss.

            // ModalDialog's own constructor already binds the close button via
            // this.querySelector('[id^="ModalClose-"]'), but that's a single
            // point of failure we don't control — belt-and-suspenders listener
            // directly on our own reference to it.
            if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.hide());

            if (this.form) this.form.addEventListener('submit', this.handleSubmit.bind(this));
            if (this.audioToggle) this.audioToggle.addEventListener('click', this.handleAudioToggle.bind(this));

            this.scheduleAutoOpen();
          }

          withinDateWindow() {
            var now = Date.now();
            if (this.config.startsAt) {
              var startsMs = new Date(this.config.startsAt).getTime();
              if (!isNaN(startsMs) && now < startsMs) return false;
            }
            if (this.config.endsAt) {
              var endsMs = new Date(this.config.endsAt).getTime();
              if (!isNaN(endsMs) && now > endsMs) return false;
            }
            return true;
          }

          scheduleAutoOpen() {
            // TEMP, testing-phase only: when the metaobject's testing_mode
            // checkbox is on, skip the submitted/dismissed localStorage gates
            // entirely so QA sees the popup on every reload. Remove this
            // field + the branch below once the popup is ready for production.
            if (!this.config.testingMode) {
              if (safeGet(this.submittedKey)) return;

              var dismissedAt = safeGet(this.dismissedKey);
              if (dismissedAt) {
                var elapsed = Date.now() - parseInt(dismissedAt, 10);
                if (!isNaN(elapsed) && elapsed < 24 * 60 * 60 * 1000) return;
              }
            }

            if (!this.withinDateWindow()) return;

            var delayMs = (this.config.delaySeconds || 3) * 1000;
            this.autoOpenTimer = window.setTimeout(() => {
              if (this.withinDateWindow()) this.show();
            }, delayMs);
          }

          show(opener) {
            super.show(opener);
            this.attachVideo();
            pushDataLayer({ event: 'teaser_popup_view', teaser: this.config.sourceLabel });
          }

          hide() {
            super.hide();
            if (this.videoEl) {
              this.videoEl.pause();
              this.videoEl.muted = true;
            }
            if (this.audioToggle) {
              this.audioToggle.setAttribute('aria-pressed', 'false');
              this.audioToggle.setAttribute('aria-label', 'Unmute video');
              this.audioToggle.setAttribute('data-audio-state', 'muted');
            }

            if (!this.submittedThisSession) {
              safeSet(this.dismissedKey, String(Date.now()));
            }
          }

          attachVideo() {
            if (!this.videoEl || !this.config.videoUrl) return;
            if (this.videoEl.dataset.attached) {
              this.videoEl.play().catch(() => {});
              return;
            }
            var source = document.createElement('source');
            source.src = this.config.videoUrl;
            source.type = 'video/mp4';
            this.videoEl.appendChild(source);
            this.videoEl.dataset.attached = 'true';
            this.videoEl.load();
            this.videoEl.muted = true;
            this.videoEl.play().catch(() => {});
          }

          handleAudioToggle() {
            if (!this.videoEl) return;
            var nextMuted = !this.videoEl.muted;
            this.videoEl.muted = nextMuted;

            var playAttempt = this.videoEl.play();
            if (playAttempt && typeof playAttempt.catch === 'function') {
              playAttempt.catch(() => {
                this.videoEl.muted = true;
                this.updateAudioToggleUI();
              });
            }

            this.updateAudioToggleUI();

            if (!this.videoEl.muted && !this.hasUnmuted) {
              this.hasUnmuted = true;
              pushDataLayer({ event: 'teaser_popup_unmute', teaser: this.config.sourceLabel });
            }
          }

          updateAudioToggleUI() {
            if (!this.audioToggle || !this.videoEl) return;
            var isMuted = this.videoEl.muted;
            this.audioToggle.setAttribute('aria-pressed', String(!isMuted));
            this.audioToggle.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
            this.audioToggle.setAttribute('data-audio-state', isMuted ? 'muted' : 'unmuted');
          }

          isValidEmail(value) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          }

          setStatus(message, state) {
            if (!this.statusEl) return;
            this.statusEl.textContent = message;
            if (state) {
              this.statusEl.setAttribute('data-state', state);
            } else {
              this.statusEl.removeAttribute('data-state');
            }
          }

          handleSubmit(event) {
            event.preventDefault();

            if (this.honeypotInput && this.honeypotInput.value) {
              // Likely a bot: pretend success, send nothing.
              this.onSubmitSucceeded();
              return;
            }

            var email = this.emailInput ? this.emailInput.value.trim() : '';
            if (!this.isValidEmail(email)) {
              this.setStatus('Please enter a valid email address.', 'error');
              if (this.emailInput) this.emailInput.focus();
              return;
            }

            var payload = {
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: this.config.sourceLabel,
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        properties: {
                          teaser_source: this.config.sourceLabel,
                          teaser_page: this.config.currentPath,
                          market: this.config.market,
                          locale: this.config.locale,
                        },
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: this.config.klaviyoListId,
                    },
                  },
                },
              },
            };

            this.submitBtn.disabled = true;
            if (this.submitCopy) this.submitCopy.textContent = '…';
            this.setStatus('', null);

            fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.config.klaviyoPublicKey), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: KLAVIYO_API_REVISION,
              },
              body: JSON.stringify(payload),
            })
              .then((res) => {
                if (res.status === 202) {
                  this.onSubmitSucceeded();
                } else {
                  return res.text().then((text) => {
                    console.error('[teaser-popup] Klaviyo subscription failed', res.status, text);
                    this.onSubmitFailed();
                  });
                }
              })
              .catch((error) => {
                console.error('[teaser-popup] Klaviyo subscription network error', error);
                this.onSubmitFailed();
              })
              .finally(() => {
                this.submitBtn.disabled = false;
                if (this.submitCopy) this.submitCopy.textContent = this.defaultSubmitCopy;
              });
          }

          onSubmitSucceeded() {
            this.submittedThisSession = true;
            safeSet(this.submittedKey, '1');
            this.setStatus(this.config.successMessage, 'success');
            if (this.form) this.form.hidden = true;
            pushDataLayer({ event: 'teaser_popup_submit', teaser: this.config.sourceLabel });
            // No auto-close: the submitted flag already prevents this popup
            // from reappearing, so there's no resubmission risk — only the
            // risk of a shopper missing the success message because it
            // vanished before they read it. Let them dismiss it themselves
            // (close button or Esc).
          }

          onSubmitFailed() {
            this.setStatus('Something went wrong. Please try again.', 'error');
          }
        }

        if (!customElements.get('ww-teaser-popup')) {
          customElements.define('ww-teaser-popup', WwTeaserPopup);
        }
      })();
  } catch(e) { console.error(e); }
})();

})();
